export const orgVisibility = ['Public', 'Route Managers Only', 'Members Only']
export const userVisibility = ['Public', 'Private', 'Friends Only']
